export default "__VITE_ASSET__DOoFwliI__"